import { render, staticRenderFns } from "./Explanation.vue?vue&type=template&id=39a4b488&scoped=true&"
import script from "./Explanation.vue?vue&type=script&lang=ts&"
export * from "./Explanation.vue?vue&type=script&lang=ts&"
import style0 from "./Explanation.vue?vue&type=style&index=0&id=39a4b488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a4b488",
  null
  
)

export default component.exports